var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgArrowRed = function SvgArrowRed(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow",
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "primary-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.55005 7.65033L6.83997 5.13031H0V4.0603H6.83997L4.55005 1.54028L5.32007 0.800293L8.75 4.60028L5.32007 8.40033L4.55005 7.65033Z",
    fill: "#F35A0C"
  })), /*#__PURE__*/React.createElement("g", {
    className: "secondary-arrows"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03071 1.11523L12.1741 4.59063L9.03071 8.06602L8.28906 7.39523L10.8257 4.59063L8.28906 1.78602L9.03071 1.11523Z",
    fill: "#F35A0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5809 1.7356L15.1523 4.59024L12.5809 7.44489L11.8379 6.7756L13.8064 4.59024L11.8379 2.40489L12.5809 1.7356Z",
    fill: "#F35A0C"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dist/media/arrow-red.86d0154a307d892c511c09d4b95e902f.svg";